export const emptyDocuments = {
  title: "Документов пока нет",
  description:
    "Загрузите первый документ, чтобы он стал доступен поиску и AI.",
  action: { href: "/documents", label: "Загрузить документ" },
} as const;

export const emptySearch = {
  title: "Ничего не найдено",
  description:
    "Попробуйте другие слова или спросите AI по доступным документам.",
} as const;

export const askAboutResultsLabel = "Спросить AI об этих результатах";

export function emptySearchAction(query: string): { href: string; label: string } {
  return {
    href: `/chat?q=${encodeURIComponent(query)}`,
    label: "Спросить AI",
  };
}
